import { MutationTree } from 'vuex';
import { ISignState } from './signature.types';

const signMutations: MutationTree<ISignState> = {
  setSignature(state, signature: string): void {
    state.signature = signature;
  },
};

export default signMutations;
